<script>
  export let message = '';

  $: text = typeof message === 'string' ? message : message == null ? '' : String(message);
</script>

{#if text}
  <p class="text-message">{text}</p>
{/if}

<style>
  .text-message {
    margin: 0;
    line-height: 1.375;
    white-space: pre-line;
    user-select: text;
  }
</style>
